import React from 'react'
import { connect } from 'react-redux'
import HeaderTitle from '../components/HeaderTitle.jsx'
import ServicesItem from '../components/ServicesItem.jsx'

const ServicesItemContainer = props => (
    <div className="section-spacing section-spacing--first">
        <HeaderTitle title={props.langData.title} className="header1--center header1--bigmargin" />
        <div className="section-spacing" id="gradevinarstvo">
            <ServicesItem
                textOnRight
                title={props.langData.box1.title}
                text={props.langData.box1.text}
                itemArray={props.langData.box1.items}
                backgroundImage="/images/bck/bed_servicesleft.jpg"
                foregroundImage={props.langData.box1.image}
                foregroundTop="6%"
                buttonTitle={props.langData.box1.button}
                link="/kontakt/1"
            />
        </div>
        <div className="section-spacing" id="projektiranje">
            <ServicesItem
                textOnRight={false}
                title={props.langData.box2.title}
                text={props.langData.box2.text}
                itemArray={props.langData.box2.items}
                backgroundImage="/images/bck/bed_servicesright.jpg"
                foregroundImage={props.langData.box2.image}
                foregroundTop="3%"
                buttonTitle={props.langData.box2.button}
                link="/kontakt/0"
            />
        </div>
        <div className="section-spacing" id="nadzor">
            <ServicesItem
                textOnRight
                title={props.langData.box3.title}
                text={props.langData.box3.text}
                itemArray={props.langData.box3.items}
                backgroundImage="/images/bck/bed_servicesleft.jpg"
                foregroundImage={props.langData.box3.image}
                foregroundTop="0%"
                buttonTitle={props.langData.box3.button}
                link="/kontakt/2"
            />
        </div>
    </div>
)

const mapStateToProps = state => ({
    langData: state.langData.services
})

export default connect(mapStateToProps)(ServicesItemContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/ServicesItemContainer.jsx